import * as Sentry from "@sentry/react";
import { ConfigProvider } from "antd";
import App from "portal/App";
import config from "portal/envConfig";
import React from "react";
import { createRoot } from "react-dom/client";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import "./index.css";

Sentry.init({
  environment: config.aktosEnv,
  dsn: config.sentryDsn,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      ),
    }),
    new Sentry.Replay({
      maskAllText: false,
    }),
  ],
  tracesSampleRate: config.aktosEnv === "prod" ? 0.01 : 1.0,
  tracePropagationTargets: ["localhost", config.apiBaseUrl],

  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
});

Sentry.configureScope((scope) => {
  // Tag all events coming out of this app as 'frontend'.
  // This tag helps us differentiate frontend events from backend events.
  scope.setTag("service", "frontend");
});

const container = document.getElementById("root");
const root = createRoot(container);

const theme = {
  token: {
    colorPrimary: "#1677ff",
    colorLink: "#0098ed",
  },
};

root.render(
  <React.StrictMode>
    <ConfigProvider theme={theme}>
      <App />
    </ConfigProvider>
  </React.StrictMode>,
);
